const hasUpperCase = (val: string): boolean => val.toLowerCase() !== val;

export default hasUpperCase;
